import {StoreAppAPI} from '../../core/src/storeapp-api-client';

export const fetchProductGroups = (skuIdArray) => (dispatch) => {
  let storeAppAPI = new StoreAppAPI();

  return storeAppAPI.product.search({ "sku":  skuIdArray.join(",") }).then((response) => {
      if(response) {
        return response.data.result;
      }

    }).catch((error) => {
      console.log(error)
    });
};
